import React, { useCallback, useEffect, useState } from 'react';
import {
  IValidationHelperProps,
  FlagPhonePickerStyle,
  IStringEvent,
  IOverrideStyles,
} from './types';
import FlagPhonePickerReact from './index';
import PhoneNumberService from 'external-services/phone-number-service';
import { phoneNumberTypes } from 'external-services/phone-number-service/phoneNumber.types';

const NS = 'FlagPhonePickerValidationHelper';

export default function FlagPhonePickerValidationHelper(props: IValidationHelperProps) {
  const {
    customerSelected,
    customerCountry,
    customerPhone,
    customerSearch,
    handlePhoneChange,
    setPhoneValid,
    setPhoneTouched,
    setPhoneWithoutPrefix,
    label,
    validationError,
    maxLength,
    forceTouched,
    classPrefix,
    skipAutoComplete,
    usePlaceholderForLabel,
    isDropDownListMoveUp,
    disabled,
    overrideStyles = {} as IOverrideStyles,
    name = 'phone',
    uiStyle = FlagPhonePickerStyle.diary,
    isPhoneIcon = false,
    isNewCustomerForm = false,
    autoFocusOnLoad,
    shouldSkipAutoFocus
  } = props;
  const [isPhoneReady, setIsPhoneReady] = useState(props.customerPhone ? false : true)
  const [phone, setPhone] = useState<string>('');
  const [country, setCountry] = useState<string>('');
  const [touched, setTouched] = useState<boolean>(!!forceTouched);

  const [customers, setCustomers] = useState<any[]>([]);
  const [searchTimeout, setSearchTimeout] = useState(null);

  useEffect(() => {
    formatPhone(customerPhone);
  }, [customerPhone]);

  useEffect(() => {
    validation();
  }, [phone]);

  useEffect(() => {
    if (customerPhone.length && phone.length && !isPhoneReady) {
      setIsPhoneReady(true)
    }
  }, [phone, customerPhone]);

  useEffect(() => {
    validation();
  }, [country]);

  const validation = () => {
    if (setPhoneValid) {
      if (
        phone &&
        !PhoneNumberService.formatNumber(phone, country, true, phoneNumberTypes.INTERNATIONAL)
      ) {
        setPhoneValid(true);
      } else {
        setPhoneValid(false);
      }
    }
  };

  const formatPhone = (phoneStr: string) => {
    let _customerCountry: string;
    let _customerFormattedPhone: string = phoneStr;
    if (phoneStr) {
      const parseNumber: any = PhoneNumberService.parseNumber(phoneStr, true);
      if (parseNumber && typeof parseNumber !== 'string') {
        if (parseNumber.nationalNumber) {
          _customerCountry = parseNumber.country;
          _customerFormattedPhone = parseNumber.nationalNumber;
        }
      } else {
        const countryOnly = PhoneNumberService.getCountryByDialCode(phoneStr);
        if (countryOnly) {
          _customerCountry = countryOnly.code;
          _customerFormattedPhone = '';
        }
      }
    }
    const tempCountry = _customerCountry || country || customerCountry || 'AU';
    country !== tempCountry && setCountry(tempCountry);
    _customerFormattedPhone !== phone && setPhone(_customerFormattedPhone);
  };

  const searchCustomer = (e: { target: IStringEvent }, countryCode: string = null) => {
    if (e && customerSearch) {
      const phoneStr = e.target.value;
      !skipAutoComplete &&
        phoneStr &&
        phoneStr.length > 1 &&
        customerSearchDebounce(phoneStr, countryCode);
      !skipAutoComplete && !phoneStr && setCustomers([]);
      if (setPhoneWithoutPrefix) {
        setPhoneWithoutPrefix(phoneStr);
      }
    }
  };
  const customerSearchDebounce = useCallback(
    (phoneStr: string, countryCode: string) => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
      setSearchTimeout(
        setTimeout(() => {
          customerSearch(phoneStr, countryCode)
            .then((res: any) => {
              setCustomers(res);
            })
            .catch(() => {
              setCustomers([]);
            });
        }, 1500)
      );
    },
    [searchTimeout, customerSearch]
  );
  const handleBlur = () => {
    setTouched(true);
    setPhoneTouched && setPhoneTouched(true);
  };

  const _handleChange = (e: { target: IStringEvent }) => {
    const name = e.target.name;
    const value = e.target.value;

    let _country = country;
    let _phone = phone;

    if (name === 'phone') {
      setPhone(value);
      _phone = value;
      setPhoneTouched && setPhoneTouched(true);
    } else if (name === 'country') {
      setCountry(value);
      _country = value;
      setPhoneTouched && setPhoneTouched(true);
    }
    setTouched(true);
    let formattedNumber = PhoneNumberService.formatNumber(_phone, _country, true);
    if (!formattedNumber && _phone)
      formattedNumber = PhoneNumberService.getCountryByCountryCode(_country).dial_code + _phone;
    handlePhoneChange(formattedNumber, _phone);
  };

  const handleWholeFormChangeForAutocomplete = (value: any) => {
    customerSelected(value);
  };
  if (!overrideStyles.focusedColor) {
    overrideStyles.focusedColor = '#992662';
  }
  return (
    isPhoneReady ? <FlagPhonePickerReact
      uiStyle={uiStyle}
      isNewCustomerForm={isNewCustomerForm}
      isPhoneIcon={isPhoneIcon}
      searchCustomer={searchCustomer}
      customers={customers}
      includeAutocomplete={!skipAutoComplete || !!props.customerSearch}
      value={phone}
      handleBlur={handleBlur}
      handleChange={_handleChange}
      country={country}
      label={label}
      handleWholeFormChangeForAutocomplete={handleWholeFormChangeForAutocomplete}
      forceValidation={true}
      touched={touched}
      errors={validationError}
      maxLength={maxLength}
      classPrefix={classPrefix}
      usePlaceholderForLabel={usePlaceholderForLabel}
      isDropDownListMoveUp={isDropDownListMoveUp}
      disabled={disabled}
      overrideStyles={overrideStyles}
      name={name}
      autoFocusOnLoad={autoFocusOnLoad}
      shouldSkipAutoFocus={shouldSkipAutoFocus}
    /> : null
  );
}
